import { useState } from 'react'

import { performRentalPortalApplicantTransition } from '../../../../../../../api'
import { useUserData } from '../../../../../../../hooks'
import {
  getIsMockApplicantId,
  postMockApplicantDecision,
} from '../../../../../../RentalPortalApplicant'
import {
  ApplicantDecisionModal,
  getIsApplicantBlockConflictError,
} from '../../../..'
import { APPLICANT_DECISION_TRANSITION_ACTION } from '../../ApplicantDecisionPanel.constants'
import {
  getApplicantDecisionConflictKey,
  getApplicantDecisionCurrentConflictKey,
} from '../../ApplicantDecisionPanel.utils'

export function useApplicantDecisionActions({
  applicantData,
  applicantId,
  handleCloseModal,
  handleEntityReload,
  setModal,
}) {
  const currentUser = useUserData()

  const [conflict, setConflict] = useState(null)

  function requestDecision({ action, note }) {
    return getIsMockApplicantId(applicantId)
      ? postMockApplicantDecision({
          action,
          applicantId,
          currentUser,
          note,
        })
      : performRentalPortalApplicantTransition({
          action: APPLICANT_DECISION_TRANSITION_ACTION[action],
          data: { note },
          id: applicantId,
        })
  }

  async function submitDecision({ action, note }) {
    setConflict(null)

    try {
      await requestDecision({ action, note })
    } catch (error) {
      if (!getIsApplicantBlockConflictError(error)) {
        throw error
      }

      setConflict({ applicantId, key: getApplicantDecisionConflictKey(error) })
    }

    handleCloseModal()

    await handleEntityReload()
  }

  function handleClickAction(action) {
    setConflict(null)

    setModal(
      <ApplicantDecisionModal
        action={action}
        applicantData={applicantData}
        onClose={handleCloseModal}
        onSubmit={note => submitDecision({ action, note })}
      />
    )
  }

  return {
    conflictKey: getApplicantDecisionCurrentConflictKey({
      applicantId,
      conflict,
    }),
    handleClickAction,
  }
}
